import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import useDebounce from '@UI/Hooks/useDebounce';
import aiModelFiltersSignal, {
	setAiModelFilters,
} from '@UI/Pages/Administration/AiEngines/Sections/ModelsSection/Filters/Signals/aiModelFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { InputText } from '@verclam/ui-kit';

const SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS = 300;

/**
 * Keeps local state for immediate keystroke feedback while the write to `aiModelFiltersSignal` is
 * debounced; the local state follows the signal so an external reset empties the field.
 */
const SearchFilter: React.FC = () => {
	const currentFilters = useSignalValue(aiModelFiltersSignal);
	const [searchInput, setSearchInput] = React.useState(currentFilters.search);
	const debouncedSearch = useDebounce(searchInput, SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS);

	React.useEffect(() => {
		setSearchInput(currentFilters.search);
	}, [currentFilters.search]);

	React.useEffect(() => {
		if (debouncedSearch === aiModelFiltersSignal.peek().search) {
			return;
		}

		setAiModelFilters(aiModelFiltersSignal.peek().setSearch(debouncedSearch));
	}, [debouncedSearch]);

	const handleSearchChange = React.useCallback((value: string) => {
		setSearchInput(value);
	}, []);

	const handleSearchBlur = React.useCallback(() => {
		if (searchInput === aiModelFiltersSignal.peek().search) {
			return;
		}

		setAiModelFilters(aiModelFiltersSignal.peek().setSearch(searchInput));
	}, [searchInput]);

	return (
		<InputText
			name="aiModelSearch"
			label="Recherche"
			isLabelHidden
			placeholder="Nom ou identifiant du modèle"
			value={searchInput}
			onChange={handleSearchChange}
			onBlur={handleSearchBlur}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default SearchFilter;
